import { useAffiliate } from '../api/affiliates/useAffiliate';
import useAuthenticatedUser from '../api/user/useAuthenticatedUser';
import { Affiliate } from '../models/affiliate';

// Resolves the current referrer affiliate. Callers derive whatever they
// need from it (e.g. `.is_saml`, `.utm_source`).
export const useReferrer = (): Affiliate | undefined => {
  const { user: authenticatedUser } = useAuthenticatedUser();
  const { affiliate: authenticatedReferrer } = useAffiliate({
    affiliateId: authenticatedUser?.referrer,
  });
  const { affiliate: utmSourceReferrer } = useAffiliate();

  // if logged in, use their referrer; otherwise fall back to utm_source
  return authenticatedReferrer || utmSourceReferrer;
};
